<script setup>
import { ref, onMounted } from "vue";
//import Conf from '@/Components/MainGlobal.vue';
import SeoMeta from '@/Components/SeoMeta.vue';
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeCheckbox from '@/Components/Checkbox.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
//import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import BreezeApplicationLogoFull from '@/Components/ApplicationLogoFull.vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';
import BaseButton from "@/Components/BaseButton.vue";
import Footer from '@/Components/Footer.vue';
import { Inertia } from '@inertiajs/inertia';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import { defineComponent } from 'vue';
import '@splidejs/vue-splide/css';
import BaseIcon from "@/Components/BaseIcon.vue";
import helpers from '../Common/helpers';
import {
    mdiMagnify,
    mdiChevronDown,
    mdiAccountOutline,
    mdiCartOutline,
    mdiHeartOutline,
    mdiMenu,
    mdiCloseThick,
    mdiToggleSwitchOffOutline,
    mdiCheckboxOutline,
    mdiHeadset,
    mdiFacebook,
    mdiInstagram,
    mdiTwitter,
    mdiWhatsapp,
    mdiYoutube,
    mdiTruckFastOutline,
    mdiReload,
    mdiShieldLockOutline,
    mdiTrophyOutline,
    mdiArrowRight,
    mdiShoppingOutline,
    mdiStar,
    mdiArrowExpandAll,
    mdiRepeat,
    mdiChevronRight,
    mdiMinus,
    mdiPlus,
    mdiFlagVariant,
    mdiMoped,
    mdiPercent,
    mdiArchivePlus,
    mdiAirplane

} from "@mdi/js";

const props = defineProps({
    canLogin: Boolean,
    canRegister: Boolean,
    laravelVersion: String,
    phpVersion: String,
    appVersion: String,
    contentWelcome: String,
    accessStudents: Boolean,
    accessParents: Boolean,
    object: Object,
    parent: String,
    label: String,
    tallas: Array,
    categoryChild: Object,
    categoryParent: Object,
    brands: Object,
    brandsrecomendadas: Object,
    originbrand: Number
    //productsdefault: Object

})

// LRR
//const confGlobal = props.connstantes
/*const confGlobal = ref([])
onMounted(() => {
  let url = '/constante/global';
  axios.get(url).then(function (response) {
      var respuesta = response.data;
      confGlobal.value = respuesta.constantes;
      //console.log(me.constante);
    }).catch(function (error) {
        console.log(error);
  });
});
*/
//console.log( props.connstantes )

const form = useForm({
    email: '',
    nombre: '',
    phone: '',
    comment: '',
    recibirinfo: false
});
const isModalActive = ref(false);

const stocklabel = ref(false)


// Información de Slide, limite x 4
onMounted(() => {
    getData(1)
});

const emit = defineEmits(["cancel", "confirm", "reload"])

const products = ref([])
const filterBrand = ref([])
const filterStatusStock = ref([])
const orderBy = ref(0)
const getData = (init = 0) => {
    let url = '/ecommerce/getproducts';
    /* let origintype = mainStore.originType;
    if (origintype == 'classroom' && mainStore.originId) {
        url = '/students/classroom?id_classroom=' + mainStore.originId;// /students/classroom'+'?id_classroom='+id_classroom
    } else if (origintype && origintype.includes('file_document_', 0)) { // <-- Pestaña Documentos
        url = '/document/' + mainStore.originType + '?src_object_id=' + mainStore.originId;
    } */

    //console.log(filterBrand.value)
    //console.log(props.originbrand)
    if (init == 1 && props.originbrand > 0) {
        filterBrand.value = [props.originbrand]
    }

    let params = {
        'filterBrand': filterBrand.value,
        'filterStatusStock': filterStatusStock.value,
        'filterCatParent': (props.parent ? props.parent : 0),
        'filterCatChild': (props.object ? props.object.id : 0), // origen es categoría
        'filterLabel': (props.label ? props.label : ''),
        'order': orderBy.value
    }

    //loading.value = true;
    axios.post(url, params).then((response) => {
        products.value = response.data;
        console.log('filter order ok');
    }).catch((error) => {
        console.log(error);
    });
    //loading.value = false;
}

const qtyCart = ref(0)
const getCart = () => {
    let cart = []
    //let cartStorage = localStorage.getItem('cart')
    let cartStorage = sessionStorage.getItem('cart')
    if (cartStorage && cartStorage.length > 0) {
        cart = JSON.parse(cartStorage)
    }
    return cart
}

const addCart = (prodid = 0, cant = 1, ref = '', label = '', price = '') => {
    let cart = getCart()
    //let newObj = {'id': prodid, 'cant': cant}
    let newObj = { 'id': prodid, 'cant': cant, 'ref': ref, 'label': label, 'price': price }
    if (cart && cart.length > 0) {
        let obj = cart.find(o => o.id === prodid)
        if (obj !== undefined && obj !== null) {
            obj.cant += cant
        } else {
            cart.push(newObj)
        }
        sessionStorage.setItem('cart', JSON.stringify(cart))
        qtyCart.value = cart.length
        console.log('Upd Cart')
    } else {
        let newCart = [newObj]
        //localStorage.setItem('cart', JSON.stringify(newCart))
        sessionStorage.setItem('cart', JSON.stringify(newCart))
        qtyCart.value = newCart.length
        console.log('New Cart')
    }
    //emit('reload')

}

//produtos nuevos ORDER BY created_at LIMIT 8
const productosNuevos = ref(null)
productosNuevos.value = [
    { 'id': '11', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/01.jpg' },
    { 'id': '12', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 0, 'rating': 1, 'stock': '0', 'ruta_imagen': '/img/productos/02.jpg' },
    { 'id': '13', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 0, 'stock': '2', 'ruta_imagen': '/img/productos/03.jpg' },
    { 'id': '14', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/04.jpg' },
    { 'id': '15', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '1', 'ruta_imagen': '/img/productos/05.jpg' },
    { 'id': '16', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/06.jpg' },
    { 'id': '17', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/07.jpg' },
    { 'id': '18', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/08.jpg' },
    { 'id': '19', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/01.jpg' },
    { 'id': '20', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 0, 'rating': 1, 'stock': '0', 'ruta_imagen': '/img/productos/02.jpg' },
    { 'id': '21', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 0, 'stock': '2', 'ruta_imagen': '/img/productos/03.jpg' },
    { 'id': '22', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/04.jpg' },
    { 'id': '23', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '1', 'ruta_imagen': '/img/productos/05.jpg' },
    { 'id': '24', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/06.jpg' },
    { 'id': '25', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/07.jpg' },
    { 'id': '26', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/08.jpg' }
]


const productosDestacados = ref(null)
productosDestacados.value = [
    { 'id': '31', 'label': 'Monitor Curvo Samsung 49″ WQLED LS49A950', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/20.jpg' },
    { 'id': '32', 'label': 'Tablet Samsung Galaxy Tab S7 Fe 64gb', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/21.jpg' },
    { 'id': '33', 'label': 'Asus ROG Strix RX5700 XT O8G 8GB', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/22.jpg' },
    { 'id': '34', 'label': 'Impresora HP LaserJet 107W', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/23.jpg' },
    { 'id': '35', 'label': 'Impresora Multifuncional Epson EcoTank L3110', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/24.jpg' },
    { 'id': '36', 'label': 'Mochila Lenovo Thinkpad Professional G2', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/25.jpg' }
]

const marcasRelacionadas = ref(null)
marcasRelacionadas.value = [
    { 'id': '101', 'ruta_imagen': '/img/marcas/01.png' },
    { 'id': '102', 'ruta_imagen': '/img/marcas/02.png' },
    { 'id': '103', 'ruta_imagen': '/img/marcas/03.png' },
    { 'id': '104', 'ruta_imagen': '/img/marcas/04.png' },
    { 'id': '105', 'ruta_imagen': '/img/marcas/05.png' },
    { 'id': '106', 'ruta_imagen': '/img/marcas/06.png' },
    { 'id': '107', 'ruta_imagen': '/img/marcas/07.png' },
    { 'id': '108', 'ruta_imagen': '/img/marcas/08.png' },
    { 'id': '109', 'ruta_imagen': '/img/marcas/09.png' },
    { 'id': '110', 'ruta_imagen': '/img/marcas/10.png' },
    { 'id': '111', 'ruta_imagen': '/img/marcas/11.png' },
    { 'id': '112', 'ruta_imagen': '/img/marcas/12.png' }
]

</script>

<script>

import { Splide, SplideSlide } from '@splidejs/vue-splide';


export default defineComponent({
    name: 'ThumbnailsExample',

    components: {
        Splide,
        SplideSlide,
    },

    setup() {
        // const main = ref < InstanceType < typeof Splide >> ();
        // const thumbs = ref < InstanceType < typeof Splide >> ();
        const slides = generateSlides();


        onMounted(() => {
            const thumbsSplide = thumbs.value?.splide;

            if (thumbsSplide) {
                main.value?.sync(thumbsSplide);
            }
        });

        return {
            slides,
            main,
            thumbs,
            mainOptions,
            thumbsOptions,
        }
    },
});


// menu filtro
const sidemenuactive = ref(false)
const sidebaractive = ref(false)
const navClosedActive = ref(false)
const navOpenActive = ref(true)

const sidemenu = () => {
    sidemenuactive.value = !sidemenuactive.value

    if (sidemenuactive.value) {
        sidebaractive.value = true
        navClosedActive.value = true
        navOpenActive.value = false
    } else {
        sidemenuactive.value = false
        sidebaractive.value = false
        navClosedActive.value = false
        navOpenActive.value = true
    }
}

let myRadios = document.getElementsByName('filtromenu');
let setCheck;
let x = 0;
for (x = 0; x < myRadios.length; x++) {
    myRadios[x].onclick = function () {
        if (setCheck != this) {
            setCheck = this;
        } else {
            this.checked = false;
            setCheck = null;
        }
    };
}

const urlNow = ref(window.location.origin)

</script>



<template>
    <SeoMeta />

    <!-- Head con categorías -->
    <BreezeGuestLayout :categoryChild="categoryChild" :categoryParent="categoryParent" :filterCat="(object && !parent ? object.id : 0)" :filterLab="(label ? label : '')" :qtyCart="qtyCart">

        <!-- Sidebar Filtro start-->

        <div class="navbar-menu relative z-[50]">
            <div :class="(sidebaractive ? 'sidebarshow' : '')" class="fixed right-0 bottom-0 flex w-full translate-x-full flex-col overflow-y-auto bg-gray-600 bg-opacity-75 transition-all duration-500 ease-in-out h-screen">
                <nav id="sidebar" class="fixed right-0 sm:max-w-xs w-3/4 lg:w-80 bg-white h-full py-8">
                    <!-- one category / navigation group -->
                    <div class="px-4 pb-6">
                        <div class="flex justify-between items-center mb-4">
                            <h3 class="text-lg font-medium  text-gray-800">
                                Filtro
                            </h3>
                            <button @click="sidemenu()">
                                <BaseIcon :path="mdiCloseThick" :size="30" class="text-gray-800" w="w-10" h="h-10" stroke="#606F7B" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                            </button>
                        </div>

                        <div class="relative h-[calc(100vh-120px)] overflow-y-auto">
                            <div class="sidebar-checkbox">
                                <div class="border-b tab">
                                    <div class="border-l-2 border-transparent relative">
                                        <input class="w-full absolute z-10 cursor-pointer opacity-0 h-7 top-4 bg-red-500" type="checkbox" id="chckfilterleft" name="categorymenuleft" checked>
                                        <header class="flex justify-between items-center p-4 cursor-pointer select-none tab-label" for="chckfilterleft">
                                            <span class="text-sm text-gray-800 font-semibold">
                                                Estado
                                            </span>
                                            <div class="rounded-lg  w-7 h-7 flex items-center justify-center tab-icon chevron ">
                                                <BaseIcon :path="mdiChevronDown" :size="24" w="w-7" h="h-7" stroke="#606F7B" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                            </div>
                                        </header>
                                        <div class="tab-content">
                                            <div class="pt-0 pb-3 px-4 ">
                                                <!-- <div class="flex items-center mb-4 checkbox-color">
                                                    <input id="checked-checkbox" type="checkbox" value="" class="w-4 h-4 rounded-sm">
                                                    <label for="checked-checkbox" class="ml-2 text-sm font-medium">En promoción</label>
                                                </div> -->
                                                <div class="flex items-center mb-4 checkbox-color">
                                                    <input id="checked-checkbox" type="checkbox" v-model="filterStatusStock" :true-value="[]" :value="1" @change="getData()" class="w-4 h-4 rounded-sm">
                                                    <label for="checked-checkbox" class="ml-2 text-sm font-medium">Stockable</label>
                                                </div>
                                                <div class="flex items-center mb-4 checkbox-color">
                                                    <input id="checked-checkbox" type="checkbox" v-model="filterStatusStock" :true-value="[]" :value="2" @change="getData()" class="w-4 h-4 rounded-sm">
                                                    <label for="checked-checkbox" class="ml-2 text-sm font-medium">A pedido</label>
                                                </div>
                                                <div class="flex items-center mb-4 checkbox-color">
                                                    <input id="checked-checkbox" type="checkbox" v-model="filterStatusStock" :true-value="[]" :value="3" @change="getData()" class="w-4 h-4 rounded-sm">
                                                    <label for="checked-checkbox" class="ml-2 text-sm font-medium">En transito</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="border-b tab">
                                    <div class="border-l-2 border-transparent relative">
                                        <input class="w-full absolute z-10 cursor-pointer opacity-0 h-7 top-4 bg-red-500" type="checkbox" id="chck3" name="categorymenuleft">
                                        <header class="flex justify-between items-center p-4 cursor-pointer select-none tab-label" for="chck3">
                                            <span class="text-sm text-gray-800 font-semibold">
                                                Marcas
                                            </span>
                                            <div class="rounded-lg w-7 h-7 flex items-center justify-center tab-icon chevron">
                                                <BaseIcon :path="mdiChevronDown" :size="24" class="" stroke="" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                            </div>
                                        </header>
                                        <div class="tab-content">
                                            <div v-if="brands.length > 0" class="pt-0 pb-3 px-4 ">
                                                <div v-for="(item, index) in brands" :key="item.id" class="flex items-center mb-4 checkbox-color">
                                                    <input id="checked-checkbox 2" type="checkbox" v-model="filterBrand" :true-value="[]" :value="item.id" @change="getData()" class="w-4 h-4 rounded-sm">
                                                    <label for="checked-checkbox 2" class="ml-2 text-sm font-medium">{{ item.label }}</label>
                                                </div>

                                                <!-- <div class="flex items-center mb-4 checkbox-color">
                                                    <input id="checked-checkbox 2" type="checkbox" value="" class="w-4 h-4 rounded-sm">
                                                    <label for="checked-checkbox 2" class="ml-2 text-sm font-medium">Asus</label>
                                                </div>
                                                <div class="flex items-center mb-4 checkbox-color">
                                                    <input id="checked-checkbox 2" type="checkbox" value="" class="w-4 h-4 rounded-sm">
                                                    <label for="checked-checkbox 2" class="ml-2 text-sm font-medium">Gigabyte</label>
                                                </div>
                                                <div class="flex items-center mb-4 checkbox-color">
                                                    <input id="checked-checkbox 2" type="checkbox" value="" class="w-4 h-4 rounded-sm">
                                                    <label for="checked-checkbox 2" class="ml-2 text-sm font-medium">D-link</label>
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <!-- navigation group end-->
                </nav>
                <div @click="sidemenu()" class="h-full overflow-hidden">
                </div>
            </div>
        </div>
        <!-- Sidebar Filtro end -->

        <!-- START NUEVOS PRODUCTOS -->
        <!-- START NUEVOS PRODUCTOS -->
        <!-- START NUEVOS PRODUCTOS -->
        <section class="py-8 xl:py-14">
            <div class="mx-auto px-4 sm:px-6 lg:px-8">
                <div class="grid xl:grid-cols-5 2xl:grid-cols-6 gap-5">

                    <!-- FILTRO DE PRODUCTOS - START -->
                    <!-- FILTRO DE PRODUCTOS - START -->
                    <!-- FILTRO DE PRODUCTOS - START -->

                    <div class="hidden xl:grid col-span-1 2xl:col-span-1">
                        <div>
                            <div class="border p-3 rounded-md">
                                <div class="p-2 pb-0 flex items-center justify-between">
                                    <h2 class="">Filtro</h2>
                                    <BaseIcon :path="mdiCheckboxOutline" :size="32" w="w-10" h="h-10" class="text-sky-500" />
                                </div>
                                <hr class="mt-4">
                                <div class="sidebar-checkbox">
                                    <div class="border-b tab">
                                        <div class="border-l-2 border-transparent relative">
                                            <input class="w-full absolute z-10 cursor-pointer opacity-0 h-7 top-4 bg-red-500" type="checkbox" id="chckfilterright" name="categorymenuright" checked>
                                            <header class="flex justify-between items-center p-4 cursor-pointer select-none tab-label" for="chckfilterright">
                                                <span class="text-sm text-gray-800 font-semibold">
                                                    Estado
                                                </span>
                                                <div class="rounded-lg  w-7 h-7 flex items-center justify-center tab-icon chevron ">
                                                    <BaseIcon :path="mdiChevronDown" :size="24" w="w-7" h="h-7" stroke="#606F7B" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                                </div>
                                            </header>
                                            <div class="tab-content">
                                                <div class="pt-0 pb-3 px-4 text-xs text-gray-600">
                                                    <!-- <div class="flex items-center mb-4 checkbox-color">
                                                        <input id="checked-checkbox" type="checkbox" value="" class="w-4 h-4 rounded-sm">
                                                        <label for="checked-checkbox" class="ml-2 text-sm font-medium">En promoción</label>
                                                    </div> -->

                                                    <div class="flex items-center mb-4 checkbox-color">
                                                        <input id="checked-checkbox" type="checkbox" v-model="filterStatusStock" :true-value="[]" :value="1" @change="getData()" class="w-4 h-4 rounded-sm">
                                                        <label for="checked-checkbox" class="ml-2 text-sm font-medium">Stockable</label>
                                                    </div>
                                                    <div class="flex items-center mb-4 checkbox-color">
                                                        <input id="checked-checkbox" type="checkbox" v-model="filterStatusStock" :true-value="[]" :value="2" @change="getData()" class="w-4 h-4 rounded-sm">
                                                        <label for="checked-checkbox" class="ml-2 text-sm font-medium">A pedido</label>
                                                    </div>
                                                    <div class="flex items-center mb-4 checkbox-color">
                                                        <input id="checked-checkbox" type="checkbox" v-model="filterStatusStock" :true-value="[]" :value="3" @change="getData()" class="w-4 h-4 rounded-sm">
                                                        <label for="checked-checkbox" class="ml-2 text-sm font-medium">En transito</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class=" tab">
                                        <div class="border-l-2 border-transparent relative">
                                            <input class="w-full absolute z-10 cursor-pointer opacity-0 h-7 top-4 bg-red-500" type="checkbox" id="chck3" name="categorymenuright">
                                            <header class="flex justify-between items-center p-4 cursor-pointer select-none tab-label" for="chck3">
                                                <span class="text-sm text-gray-800 font-semibold">
                                                    Marcas
                                                </span>
                                                <div class="rounded-lg w-7 h-7 flex items-center justify-center tab-icon chevron">
                                                    <BaseIcon :path="mdiChevronDown" :size="24" class="" stroke="#606F7B" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                                </div>
                                            </header>
                                            <div class="tab-content">
                                                <div v-if="brands.length > 0" class="pt-0 pb-3 px-4 text-xs text-gray-600">
                                                    <div v-for="(item, index) in brands" :key="item.id" class="flex items-center mb-4 checkbox-color">
                                                        <input id="checked-checkbox 2" type="checkbox" v-model="filterBrand" :true-value="[]" :value="item.id" @change="getData()" class="w-4 h-4 rounded-sm">
                                                        <label for="checked-checkbox 2" class="ml-2 text-sm font-medium">{{ item.label }}</label>
                                                    </div>
                                                    <!-- <div class="flex items-center mb-4 checkbox-color">
                                                        <input id="checked-checkbox 2" type="checkbox" value="" class="w-4 h-4 rounded-sm">
                                                        <label for="checked-checkbox 2" class="ml-2 text-sm font-medium">Asus</label>
                                                    </div>
                                                    <div class="flex items-center mb-4 checkbox-color">
                                                        <input id="checked-checkbox 2" type="checkbox" value="" class="w-4 h-4 rounded-sm">
                                                        <label for="checked-checkbox 2" class="ml-2 text-sm font-medium">Gigabyte</label>
                                                    </div>
                                                    <div class="flex items-center mb-4 checkbox-color">
                                                        <input id="checked-checkbox 2" type="checkbox" value="" class="w-4 h-4 rounded-sm">
                                                        <label for="checked-checkbox 2" class="ml-2 text-sm font-medium">D-link</label>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- FILTRO DE PRODUCTOS - END -->
                    <!-- FILTRO DE PRODUCTOS - END -->
                    <!-- FILTRO DE PRODUCTOS - END -->

                    <!-- GRUPO DE PRODUCTOS - START -->
                    <!-- GRUPO DE PRODUCTOS - START -->
                    <!-- GRUPO DE PRODUCTOS - START -->

                    <div class="col-span-4 2xl:col-span-5">
                        <div class="flex justify-between xl:justify-start items-center mb-2">
                            <div>
                                <h1 class="sm:text-3xl text-xl font-600 leading-none">{{ (object ? object.label : 'Productos') }}</h1>
                            </div>
                            <div class="xl:hidden">
                                <button @click="sidemenu()" id="btnSidebarToggler" type="button" class="btn btn-color !py-1 !px-2 inline-flex items-center">
                                    <p class="inline-block text-md pr-2">Filtro</p>
                                    <!-- <BaseIcon v-show="navOpenActive" :path="mdiMenu" :size="28" class="" w="w-8" h="h-8"></BaseIcon>
                                    <BaseIcon v-show="navClosedActive" :path="mdiCloseThick" :size="28" class="" w="w-8" h="h-8"></BaseIcon> -->
                                    <BaseIcon :path="mdiCheckboxOutline" :size="20" w="w-6" h="h-6" class="text-white" />
                                </button>
                            </div>
                        </div>

                        <!-- <div class="w-full bg-white flex md:flex-row flex-col md:space-y-0 space-y-5 md:justify-between py-4">
                            <div>
                                <p class="text-sm lg:text-base text-gray-800"><span class="font-semibold">Productos:</span> {{ products.length }} </p>
                            </div>
                            <div class="flex justify-between lg:space-x-3 items-center">
                                <span class="text-sm text-gray-800 font-semibold">Ordenar por:</span>
                                <div>
                                    <select class="min-w-[200px]" v-model="orderBy" @change="getData()">
                                        <option selected value="0">
                                        </option>
                                        <option value="1">Precio de Menor a Mayor</option>
                                        <option value="2">Precio de Mayor a Menor</option>
                                        <option value="3">Nombre Ascendente</option>
                                        <option value="4">Nombre Descendente</option>
                                    </select>
                                </div>
                            </div>
                        </div> -->
                        <div class="w-full bg-white flex flex-row justify-between py-4">
                            <div class="flex items-center">
                                <p class="text-sm lg:text-base text-gray-800"><span class="font-semibold">Productos:</span> {{ products.length }} <!-- 1–16 de 66 resultados --></p>
                            </div>
                            <div class="flex justify-between items-center space-x-2 lg:space-x-3 ">
                                <span class="text-sm text-gray-800 font-semibold">Ordenar por:</span>
                                <select class="w-[120px] md:min-w-[150px] lg:min-w-[200px] text-xs lg:text-sm pl-2 pr-6" v-model="orderBy" @change="getData()" style="background-position: right 0.2rem center;">
                                    <option selected value="0">Ninguno</option>
                                    <option value="1">Precio de Menor</option>
                                    <option value="2">Precio de Mayor </option>
                                    <option value="3">A - Z</option>
                                    <option value="4">Z - A</option>
                                </select>

                            </div>
                        </div>
                        <hr class="my-4">

                        <div v-if="products.length > 0" class="pt-4">
                            <div class="w-full">
                                <div class="grid 2xl:grid-cols-5 xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 xl:gap-[30px] gap-5">
                                    <div v-for="(item, index) in products" :key="item.id" class="shadow-xl shadow-gray-400/10 rounded-lg border">
                                        <div class="w-full h-full bg-white relative group overflow-hidden rounded-lg">

                                            <Link :href="route('eco-product-show', { id: item.id })">
                                                <div class="h-[300px]">
                                                    <img :src="(item.files[0] ? '/documents/' + item.files[0].filepath + '/' + item.files[0].filename : '')" alt="" class="w-full h-full object-contain">
                                                </div>
                                            </Link>
                                            <div class="absolute right-[14px] top-[17px]">
                                                <div class="flex flex-col gap-2">
                                                    <!-- <div v-if="item.popular" class="absolute right-[14px] top-[17px]"><span class="text-[9px] font-700 leading-none py-[6px] px-3 uppercase text-white rounded-full bg-[#19CC40]">popular</span></div> -->
                                                    <div v-if="item.list_price_ttc > item.price_ttc" class="flex items-center justify-center rounded-full bg-rose-600 py-1 px-3">
                                                        <BaseIcon :path="mdiPercent" :size="22" class="pr-1 text-white" w="w-6" h="h-6"></BaseIcon><span class="text-xs font-700 leading-none uppercase text-white text-center"> {{ helpers.unensRound((item.list_price_ttc - item.price_ttc) * 100 / item.list_price_ttc) }} Dto. </span>
                                                    </div>
                                                    <div v-if="item.stockable_product == 3" class="flex items-center justify-center rounded-full bg-violet-600 py-1 px-3">
                                                        <BaseIcon :path="mdiAirplane" :size="22" class="pr-1 text-white" w="w-6" h="h-6"></BaseIcon><span class="text-xs font-700 leading-none uppercase text-white text-center">En transito</span>
                                                    </div>
                                                    <div v-if="item.stockable_product == 2" class="flex items-center justify-center rounded-full bg-blue-600 py-1 px-3">
                                                        <BaseIcon :path="mdiArchivePlus" :size="22" class="pr-1 text-white" w="w-6" h="h-6"></BaseIcon><span class="text-xs font-700 leading-none uppercase text-white text-center">A pedido</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="px-[30px] pb-[30px] relative">
                                                <div class="absolute w-full h-10 px-[30px] left-0 top-40 group-hover:top-[100px] transition-all duration-300 ease-in-out xl:block hidden">
                                                    <button type="button" class="btn btn-color btn-ico w-full flex justify-center" @click="addCart(item.id, 1, item.ref, item.label, item.price_ttc)">
                                                        <div class="flex items-center space-x-3">
                                                            <BaseIcon :path="mdiShoppingOutline" :size="24" class="text-white" w="w-4" h="h-4"></BaseIcon>
                                                            <span>Agregar al carrito</span>
                                                        </div>
                                                    </button>
                                                </div>

                                                <div class="flex items-center justify-between h-[30px]">
                                                    <!-- <div v-if="item.rating">
                                                        <div class="reviews flex space-x-[1px]">
                                                            <span  v-for="i in item.rating">
                                                                <BaseIcon :path="mdiStar" :size="20" class="text-yellow-400" w="w-6" h="h-6"></BaseIcon>
                                                            </span>
                                                        </div>
                                                    </div> -->
                                                    <div>
                                                        <div class="reviews flex space-x-[1px]">
                                                            <span>
                                                                {{ (item.brand ? ' ' + item.brand.label : '') }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <template v-if="Object.keys(confGlobal.value).length > 0">
                                                            <p v-if="item.stock <= 0 && confGlobal.value.PRODUCT_STOCK_ZERO_LABEL" class="text-gray-700 text-sm">
                                                                <span class="text-gray-800 font-semibold">{{ confGlobal.value.PRODUCT_STOCK_ZERO_LABEL }}</span>
                                                            </p>
                                                            <p v-else class="text-gray-700 text-sm">Stock <span class="text-gray-800 font-semibold">{{ (stocklabel ? (item.stock > parseInt(stocklabel) ? 'Disponible' : 'Limitado') : (item.stock > parseInt(confGlobal.value.PRODUCT_STOCK_LABEL || 30) ? '+ ' + (confGlobal.value.PRODUCT_STOCK_LABEL || '30') : item.stock)) }}</span></p>
                                                        </template>
                                                    </div>
                                                </div>

                                                <div class="h-[100px] grid content-between">
                                                    <div class="mb-2 limit-line line-2">
                                                        <Link :href="route('eco-product-show', { id: item.id })">
                                                        <p class="!capitalize text-[15px] font-semibold leading-[24px] line-clamp-2 a-color line-2">{{ item.label }}</p>
                                                        </Link>
                                                    </div>
                                                    <p><span v-if="item.list_price_ttc > 0" class="main-price text-gray-500 line-through font-600 text-sm">{{ helpers.currencySymbol(confGlobal.value.COMPANY_MULTICURRENCY_CODE) }} {{ item.list_price_ttc }}</span><span class="offer-price text-qred font-semibold text-base ml-2 text-gray-800">{{ helpers.currencySymbol(confGlobal.value.COMPANY_MULTICURRENCY_CODE) }} {{ item.price_ttc }}</span></p>
                                                </div>
                                                <div class="xl:hidden block mt-3">
                                                    <button type="button" class="btn btn-color btn-ico w-full flex justify-center" @click="addCart(item.id, 1, item.ref, item.label, item.price_ttc)">
                                                        <div class="flex items-center space-x-3">
                                                            <BaseIcon :path="mdiShoppingOutline" :size="24" class="text-white" w="w-4" h="h-4"></BaseIcon>
                                                            <span>Agregar al carrito</span>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                            <!-- <div class="quick-access-btns flex flex-col space-y-2 absolute group-hover:right-4 -right-10 top-20  transition-all duration-300 ease-in-out">
                                                <a href="#">
                                                    <span class="w-10 h-10 flex justify-center items-center bg-gray-200/50 rounded">
                                                        <BaseIcon :path="mdiArrowExpandAll" :size="24" class="icon-color-black" w="w-6" h="h-6"></BaseIcon>
                                                    </span>
                                                </a><a href="#">
                                                    <span class="w-10 h-10 flex justify-center items-center bg-gray-200/50 rounded">
                                                        <BaseIcon :path="mdiHeartOutline" :size="24" class="icon-color-black" w="w-6" h="h-6"></BaseIcon>
                                                    </span>
                                                </a>
                                                <a href="#">
                                                    <span class="w-10 h-10 flex justify-center items-center bg-gray-200/50 rounded">
                                                        <BaseIcon :path="mdiRepeat" :size="24" class="icon-color-black" w="w-6" h="h-6"></BaseIcon>
                                                    </span>
                                                </a>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- GRUPO DE PRODUCTOS - END -->
                    <!-- GRUPO DE PRODUCTOS - END -->
                    <!-- GRUPO DE PRODUCTOS - END -->
                </div>
            </div>
        </section>
        <!-- END NUEVOS PRODUCTOS -->
        <!-- END NUEVOS PRODUCTOS -->
        <!-- END NUEVOS PRODUCTOS -->





        <!--START MARCAS -->
        <!--START MARCAS -->
        <!--START MARCAS -->
        <section class="py-8">
            <div class="mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex justify-between items-center mb-5">
                    <div>
                        <h1 class="sm:text-3xl text-xl font-600 leading-none">Marcas que ofrecemos</h1>
                    </div>
                    <div>
                        <Link :href="route('eco-brands')">
                            <div class="flex space-x-2 items-center">
                                <p class="text-base font-600 hidden lg:block a-color">Ver Más</p>
                                <span>
                                    <BaseIcon :path="mdiArrowRight" :size="32" class="icon-color" w="w-12" h="h-12"></BaseIcon>
                                </span>
                            </div>
                        </Link>
                    </div>
                </div>

                <div class="relative slider-marcas slider-marcas-color" v-if="brandsrecomendadas.length > 0">
                    <hr class="my-4">
                    <Splide :has-track="true" :options="{ rewind: 'true', perMove: 1, type: 'loop', autoplay: true, pagination: false, arrows: true, gap: '1em', mediaQuery: 'min', breakpoints: { 1890: { perPage: 7 }, 1536: { perPage: 6 }, 1023: { perPage: 4 }, 640: { perPage: 2 }, 0: { perPage: 1 } } }" class="rounded-md" id="">
                        <SplideSlide class="rounded-md w-full h-full " v-for="(item, index) in brandsrecomendadas" :key="item.id">
                            <div class="rounded-md w-full h-[110px] lg:h-[150px] bg-white border-gray-100 border-color-light hover:border-2 flex justify-center items-center py-4 px-8 transition-transform ease-out duration-150">
                                <Link :href="route('eco-product-category', { id: 0, label: '', originbrand: item.id })" class="">
                                    <img :src="(item.files[0] ? '/documents/' + item.files[0].filepath + '/' + item.files[0].filename : '')" class="hover:grayscale h-14 xl:h-20 !object-contain transition-transform ease-out duration-150">
                                </Link>
                            </div>
                        </SplideSlide>
                    </Splide>
                    <hr class="my-4">
                </div>
            </div>
        </section>
        <!-- END MARCAS -->
        <!-- END MARCAS -->
        <!-- END MARCAS -->



        <!-- START PROMOCIONES -->
        <!-- START PROMOCIONES -->
        <!-- START PROMOCIONES -->
        <!-- <section class="py-8">
            <div class="container mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex justify-between items-center mb-5">
                    <div>
                        <h1 class="sm:text-3xl text-xl font-600 leading-none">Ultimas Promociones</h1>
                    </div>
                    <div>
                        <a href="#">
                            <div class="flex space-x-2 items-center">
                                <p class="text-base font-600 hidden lg:block a-color">Ver Más</p>
                                <span>
                                    <BaseIcon :path="mdiArrowRight" :size="32" class=" icon-color" w="w-12" h="h-12"></BaseIcon>
                                </span>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    <div class="bg-white shadow-xl shadow-gray-400/10 rounded-lg">
                        <picture class="rounded-md overflow-hidden block">
                            <a href="#"><img class="hover:scale-110 ease-in duration-500 w-full" src="/img/promociones/01.png" /></a>
                        </picture>
                    </div>
                    <div class="bg-white shadow-xl shadow-gray-400/10 rounded-lg">
                        <picture class="rounded-md overflow-hidden block">
                            <a href="#"><img class="hover:scale-110 ease-in duration-500 w-full" src="/img/promociones/02.png" /></a>
                        </picture>
                    </div>
                </div>
            </div>
        </section> -->
        <!-- END PROMOCIONES -->
        <!-- END PROMOCIONES -->
        <!-- END PROMOCIONES -->



        <!-- <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div class="grid grid-cols-2">
                <div class="col-span-1">
                    <Splide id="main-carousel" :options="{
                        type: 'fade',
                        rewind: true,
                        pagination: false,
                        arrows: false,
                    }">
                        <SplideSlide>
                            <img src="/img/productos/independiente/01.jpg" alt="Sample 1">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                        </SplideSlide>
                    </Splide>

                    <Splide :options="{
                        fixedWidth: 100,
                        fixedHeight: 60,
                        gap: 10,
                        rewind: true,
                        pagination: false,
                        cover: true,
                        focus: 'center',
                        breakpoints: {
                            600: {
                                fixedWidth: 60,
                                fixedHeight: 44,
                            },
                        },
                    }">
                        <SplideSlide>
                            <img src="/img/productos/independiente/01.jpg" alt="Sample 1">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/04.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/05.jpg" alt="Sample 2">
                        </SplideSlide>
                    </Splide>
                </div>
            </div>

        </div> -->


    </BreezeGuestLayout>
</template>

<style scoped>
.splide__slide img {

    object-fit: cover;
}
</style>
